import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import TaskForm from "./Components/TaskForm";
import TaskListMenu from "../TaskListMenu";
import useRequestFn from "utils/useRequestFn";
import {
    getActivityTaskDetail,
    queryActivityTaskList,
    ActivityTaskDetail
} from "service/group";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import { PublishStatus } from "service/group";
import useRequest from "utils/useRequest";
import { TouchedAtom } from "../../../../store";
import { useAtomValue } from "jotai";

interface StepTwoProps {
    publishStatus?: PublishStatus; //编辑时初始值
    onChangeStep: (val: number) => void;
    onCancel: () => void;
    activityId: number; //活动id
    onOk: () => void; //刷新活动列表
}

export default function StepTwo({
    publishStatus,
    onChangeStep,
    onCancel,
    activityId,
    onOk
}: StepTwoProps) {
    const touched = useAtomValue(TouchedAtom);

    const [taskId, setTaskId] = useState(-1); //任务id
    const [targetTaskId, setTargetTaskId] = useState(-1); //目标任务id
    const [taskDetail, setTaskDetail] = useState<ActivityTaskDetail | null>(
        null
    );

    //任务列表
    const [taskList, { loading }, updateTaskList] = useRequest(
        async () => {
            if (activityId && activityId > 0) {
                return queryActivityTaskList(activityId);
            } else {
                return [];
            }
        },
        {},
        [activityId]
    );

    //切换任务时,有未保存且二次确认后，进入目标任务
    useEffect(() => {
        if (!taskList || touched) return;

        if (taskList.length === 0) {
            setTaskId(-1);
            return;
        }

        if (targetTaskId === -1) {
            setTaskId(taskList[0]?.id || -1);
        } else {
            setTaskId(targetTaskId);
        }
    }, [touched, taskList, targetTaskId]);

    //任务详情
    const [getTaskListDetail, { loading: detailLoading }] = useRequestFn(
        getActivityTaskDetail
    );

    useEffect(() => {
        if (taskId && taskId !== -1) {
            getTaskDetail();
        } else {
            setTaskDetail(null);
        }
    }, [taskId]);

    const getTaskDetail = async () => {
        try {
            const data = await getTaskListDetail(taskId);
            setTaskDetail(data);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    //更新
    const handleRefreshData = async () => {
        await updateTaskList();
        await onOk();
    };

    return (
        <div className={style.root}>
            <div className={style.list}>
                <TaskListMenu
                    list={taskList || []}
                    loading={loading}
                    taskId={taskId}
                    onChangeTaskId={setTaskId}
                    onChangeTargetTaskId={setTargetTaskId}
                    onRefresh={handleRefreshData}
                />
            </div>

            <div className={style.container}>
                <TaskForm
                    status={publishStatus}
                    taskId={taskId}
                    onChangeTaskId={setTaskId}
                    taskDetail={taskDetail}
                    onChangeStep={onChangeStep}
                    onCancel={onCancel}
                    loading={detailLoading || loading}
                    onRefresh={handleRefreshData}
                />
            </div>
        </div>
    );
}
